import {ref, watch} from 'vue';

/**
 * @param {function} signCallback
 * @param {object} props
 */
export default function useEuSign(signCallback, props) {
  const signWidget = require('@/components/modal/EuSign/eusign');
  const euSign = ref(null);
  /**
   * when closing the modal window, you need to clear the widget data
   */
  const destroyWidget = () => {
    try {
      euSign.value?.ResetPrivateKey();
      euSign.value?.destroy();
    } catch (e) {
      return null;
    }
  };

  const initWidget = async () => {
    euSign.value = new signWidget.EndUser(
      'sign-widget-parent',
      'sign-widget',
      process.env.VUE_APP_WIDGET_URL,
      signWidget.EndUser.FormType.ReadPKey
    );
    try {
      await euSign.value.ReadPrivateKey();
      await signCallback();
    } catch (e) {
      console.error(`Виникла помилка при зчитуванні ос. ключа. Опис помилки: ${(e.message || e)}`);
    }
  };

  watch(() => props.active, (value) => {
    if (value) {
      initWidget();
    }
  });

  return {
    signWidget,
    euSign,
    destroyWidget,
  };
}
